import styled from '@emotion/styled';
import { DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import { theme } from 'theme';

export const StyledDialogTitle = styled(DialogTitle)`
  padding: 0px;
`;

export const DialogTitleText = styled(Stack)`
  flex-direction: row;
  align-items: center;
  font-size: 24px;
  font-weight: 700;
  line-height: 36px;
  color: ${theme.palette.primary.main};
  ${theme.breakpoints.down('sm')} {
    text-align: center;
  }
  & > p {
    font-size: 24px;
    font-weight: 700;
    line-height: 36px;
    color: ${theme.palette.primary.main};
  }
`;

export const DialogSubTitleText = styled(Stack)`
  font-size: 16px;
  font-weight: 400;
  line-height: 27px;
  color: #132f41;
  ${theme.breakpoints.down('sm')} {
    text-align: center;
  }
`;

export const StyledDialogContent = styled(DialogContent)`
  overflow-y: unset;
  margin: 0px;
  padding: 0px 5px 0px 0px !important;
  &::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${theme.palette.primary.main};
  }
`;

export const TermContentText = styled(Typography)`
  font-size: 12px;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0%;
  color: ${theme.palette.text.secondary};
  padding-right: 8px;
  & p {
    font-size: 12px;
    font-weight: 400;
    line-height: 150%;
    letter-spacing: 0%;
    color: ${theme.palette.text.secondary};
    padding-right: 8px;
  }
`;

export const TermContentTextBold = styled('span')`
  font-size: 12px;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: 0%;
  color: ${theme.palette.text.secondary};
  & p {
    font-size: 12px;
    font-weight: 700;
    line-height: 150%;
    letter-spacing: 0%;
    color: ${theme.palette.text.secondary};
  }
`;

export const TermDescriptionWrapper = styled(Stack)`
  padding: 8px 16px;
  max-height: 120px 16px;
  border-radius: 5px;
  border: 1px solid ${theme.palette.grey4.light};
  margin-left: 20px !important;
`;

export const TermViewAllWrapper = styled(Stack)`
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  ${theme.breakpoints.down('sm')} {
    /* padding-left: 25px; */
  }
  & > p {
    font-size: 12px;
    font-weight: 400;
    color: ${theme.palette.secondary.dark};
  }
  & > svg {
    color: ${theme.palette.seperators.non_opaque};
  }
`;

export const TermHeadItemWrapper = styled(Stack)`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  & .MuiCheckbox-root {
    padding: 0 0 3px 0;
    & svg {
      width: 24px;
      height: 24px;
    }
  }
  & .title-item {
    font-size: 15px;
    font-weight: 600;
    ${theme.breakpoints.down('sm')} {
      font-size: 12px;
    }
  }
  & .required-item {
    font-size: 15px;
    font-weight: 500;
    color: ${theme.palette.primary.main};
    ${theme.breakpoints.down('sm')} {
      font-size: 12px;
    }
  }
`;
